<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-treeselect
    [dt]="props.dt"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [options]="$any(props.options)"
    [parentIdentifier]="props.parentIdentifier"
    [optionValue]="props.optionValue"
    [dataKey]="props.dataKey ?? 'key'"
    [selectionMode]="props.selectionMode ?? 'single'"
    [label]="props.label"
    [filter]="props.filter ?? true"
    [filterBy]="props.filterBy"
    [showClear]="!props.required"
    [expandAll]="props.expandAll ?? true"
    [required]="props.required"
    [readonly]="props.readonly"
    [isVertical]="props.isVertical"
    [badgeDisabled]="props.badgeDisabled"
    [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    (changed)="props.change && props.change(field, $event)"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
